import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import css from '../index.module.css';

interface Props {
  title: string | ReactNode;
  link?: string;
  elements?: ReactNode;
  icon?: IconDefinition;
}

export default function DashboardTitle({
  title,
  link,
  elements = null,
  icon = null,
}: Props) {
  return (
    <div className={css['title']}>
      {link ? <Link to={link}>{title}</Link> : <span>{title}</span>}
      {elements && <span className={css['elements']}>{elements}</span>}
      {icon && (
        <span className={css['icon']}>
          <FontAwesomeIcon icon={icon} />
        </span>
      )}
    </div>
  );
}
